import { createRouter, createWebHistory } from 'vue-router'
import { routes, handleHotUpdate } from 'vue-router/auto-routes'

import { registerGuards } from '@/router/guards'

// routes are auto generated by the Vue Router file-based routing plugin

export const router = createRouter({
  history: createWebHistory(),
  routes,
  /**
   * Restore the user's scroll position when navigating back/forward.
   * On any other navigation (including initial page load) scroll to the top.
   *
   * This ensures that when a user clicks "Back" from a report detail page,
   * they are returned to the exact row they were looking at in the list.
   */
  scrollBehavior(_to, _from, savedPosition) {
    return savedPosition ?? { top: 0 }
  }
})

registerGuards(router)

if (import.meta.hot) {
  handleHotUpdate(router)
}
